/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/TriPeaksAuthority',['lodash',
		'absolute/debug',
		'util/dictionary',
		'SolitaireShared/CardLogic/IGameAuthority',
		'SolitaireShared/CardLogic/TipEventArgs',
		'SolitaireShared/CardLogic/Supply',
		'SolitaireShared/CardLogic/Card',
		'SolitaireShared/CardLogic/Pile',
		'SolitaireShared/CardLogic/CardValue',
		'SolitaireShared/CardLogic/CardSuit',
		'SolitaireShared/CardLogic/CardColor',
		'SolitaireShared/CardLogic/CardOp',
		'SolitaireShared/CardLogic/CardAction',
		'SolitaireShared/CardLogic/MoveState',
		'SolitaireShared/CardLogic/DealData',
		'util/eventhandler'],
	function (_, Debug, Dictionary, IGameAuthority, TipEventArgs, Supply, Card, Pile, CardValue, CardSuit, CardColor, CardOp, CardAction, MoveState, DealData, EventHandler) {
		"use strict";

		var TriPeaksAuthority = function () {
			this.initTriPeaksAuthority();
		};

		TriPeaksAuthority.constructor = TriPeaksAuthority;
		TriPeaksAuthority.prototype = Object.create(IGameAuthority.prototype);


		TriPeaksAuthority.prototype.initTriPeaksAuthority = function () {
			this.CardSupply = new Supply("TriPeaks");
			this.CardSupply.Authority = this;

			this.MaxDeals = 3;
			this.SuppressBonusAnimations = false;

			this.IsChallenge = false;

			this._lastHint;

			this.DealScript = TriPeaksAuthority.DefaultDealScript;

			this.WinSetAction = null;

			this.CardsClearedWerePeaks = [];

			this._currentCardsRemovedWithoutUsingStock = 0;

			this.MaxCardsRemovedWithoutUsingStock = 0;

			this.CurrentDeal = 0;
			this.TotalDeals = 0;
			this.FreeDeals = 0;

			this.NumBoardsCompleted = 0;

			this.NumPeaksCleared = 0;

			this.WonWithKing = false;

			this.CardsChained = 0;

			this._chainNumber = 0;

			//Dictionary<int, Pile> _numToTableau;
			//Dictionary<Pile, int> _tableauToNum;

			//Dictionary<int, Pile> _numToFaceDown;
			//Dictionary<Pile, int> _faceDownToNum;

			this.onBonusEffectEventHanlder = new EventHandler();

		};

		// TODO
		//public event OnTipEventHandler OnTip;
		//public event OnBonusEffectEventHandler OnBonusEffect;
		//public event OnAuthorityDealEventHanlder OnDealEvent;
		//public event EventHandler BoardCleared;


		Object.defineProperty(TriPeaksAuthority.prototype, "MAX_DEALS", {
			get: function () {
				return this.MaxDeals;
			}
		});

		var TagChainnumber = 0xFFFF;

		TriPeaksAuthority.prototype.Setup = function () {


			this._numToTableau = new Dictionary(Number, Pile);
			this._tableauToNum = new Dictionary(Pile, Number);

			this._numToFaceDown = new Dictionary(Number, Pile);
			this._faceDownToNum = new Dictionary(Pile, Number);

			for (var i = 0; i < 28; i++) {
				{
					var pileID = this.CardSupply.AddPile("FaceDown" + i, "FaceDown");
					var pile = this.CardSupply.GetPile(pileID);
					this._numToFaceDown.Add(i, pile);
					this._faceDownToNum.Add(pile, i);
				}

				{
					var pileID = this.CardSupply.AddPile("Tableau" + i, "Tableau");
					var pile = this.CardSupply.GetPile(pileID);
					this._numToTableau.Add(i, pile);
					this._tableauToNum.Add(pile, i);
				}
			}

			this.CardSupply.AddPile("Stock", "Stock");
			this.CardSupply.AddPile("Waste", "Waste");
			this.CardSupply.AddPile("Joker", "Joker");

			this.CurrentDeal = 0;
			this.NumBoardsCompleted = 0;
			this.NumPeaksCleared = 0;
			this.TotalDeals = this.MAX_DEALS;
			this.FreeDeals = 0;
			this.WonWithKing = false;

			this.CardSupply.CreateCards(1, 4, 1);
		};

		TriPeaksAuthority.prototype.Reset = function () {
			this.CardSupply.ResetGame();

			this.RemoveWildCards();

			this.MaxCardsRemovedWithoutUsingStock = 0;
			this._currentCardsRemovedWithoutUsingStock = 0;
			this.CardsClearedWerePeaks = [];

			this.CurrentDeal = 0;
			this.NumBoardsCompleted = 0;
			this.NumPeaksCleared = 0;
			this.TotalDeals = this.MAX_DEALS;
			this.FreeDeals = 0;
		};

		TriPeaksAuthority.prototype.OnBoardCleared = function () {
			var handler = this.BoardCleared;
			if (handler != null) handler.handeEvent(this/* TODO , EventArgs.Empty */);
		};

		TriPeaksAuthority.prototype.RemoveWildCards = function () {
			var wildPile = this.CardSupply.GetPile("Joker");
			if (wildPile != null)
				wildPile.ClearCards();
		};

		TriPeaksAuthority.prototype.BoardsCompleted = function () {
			return this.NumBoardsCompleted;
		};

		TriPeaksAuthority.prototype.NumDealsLeft = function () {
			return this.TotalDeals - this.CurrentDeal;
		};


		TriPeaksAuthority.prototype.ShuffleNumberToString = function (dealNum) {
			return "+SHUFFLE_" + dealNum;
		};

		TriPeaksAuthority.prototype.GetIthDeckSeed = function (i) {
			return this.CardSupply.GetOption(this.ShuffleNumberToString(i));
		};

		TriPeaksAuthority.prototype.Deal = function () {
			if (this.OnDealEvent != null)
				this.OnDealEvent();

			this.CardsClearedWerePeaks = [];

			// Get the number of deals we've done so far.
			this.CurrentDeal = this.CardSupply.NumDealsSoFar();

			var userWonBoard = false;
			if (this.CurrentDeal != 0)
				userWonBoard = this.CheckWin();

			if (!userWonBoard && this.CurrentDeal >= this.TotalDeals)
				return false;


			this.CardSupply.PrepareGame(false);

			var deckSeed = this.CurrentDeal == 0 ? this.CardSupply.DeckSeed : this.GetIthDeckSeed(this.CurrentDeal);

			// Pick the correct deck to deal (depending on which deal this is).

			if (this.CardSupply.CardAnimator != null) {
				this.CardSupply.CardAnimator.BeginShuffleAnimation();
			}

			var originalSeed = deckSeed;
			deckSeed = this.CardSupply.RootPile.Shuffle(deckSeed);
			// now log the deal we just did.
			if (originalSeed != deckSeed) {
				if (this.CurrentDeal == 0) {
					this.CardSupply.DeckSeed = deckSeed;
				}
				else {
					var optionAction = new CardAction(this.CardSupply);
					optionAction.Parse(["OPTION", this.ShuffleNumberToString(this.CurrentDeal), deckSeed]);
					optionAction.Run();
					this.CardSupply.LogAction(optionAction);
				}
			}

			// create new Option action for this deck seed and add to log?

			Debug.log("CardSupply.DeckSeed = " + this.CardSupply.DeckSeed);

			this.CardSupply.OnShuffleCards();

			// Don't enforce game rules or log moves during deal. This usually already happens in PrepareGame(true).
			this.CardSupply.EnforceGameRules = this.CardSupply.LogMoves = false;
			CardAction.RunActions(this.CardSupply, this.DealScript);

			// StartGame() inits the action log with the game and options,
			// don't do that if this is the second or third deal.
			if (this.CurrentDeal == 0) {
				this.CardSupply.StartGame();
			}
			else {
				this.CardSupply.LogMoves = true;

				this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["DEAL", deckSeed]));
				this.CardSupply.ForceDealEvent();

				this.CardSupply.EnforceGameRules = true;
			}

			this.CurrentDeal = this.CardSupply.NumDealsSoFar(); // should be 1 higher now

			if (userWonBoard && this.NumDealsLeft() < this.MAX_DEALS - 1 + this.CardSupply.NumExtraDealsSoFar()) {
				this.TotalDeals++;
				this.FreeDeals++;
				this.OnBoardCleared();
			}

			this._chainNumber = 0;

			return true;
		};

		TriPeaksAuthority.prototype.Tick = function (playedTime) {
		};

		/*               0						1						2
		 *            3		4				5		6				7		8
		 *       9		10		11		12		13		14		15		16		17
		 *  18		19		20		21		22		23		24		25		26		27
		 */

		// This is a list of which tableau numbers are blocking which other tableau numbers
		var TableauBlockers = [
			[3, 4], // tableaus blocking 0
			[5, 6], // 1
			[7, 8], // 2
			[9, 10], // 3
			[10, 11], // 4
			[12, 13], // 5
			[13, 14], // 6
			[15, 16], // 7
			[16, 17], // 8
			[18, 19], // 9
			[19, 20], // 10
			[20, 21], // 11
			[21, 22], // 12
			[22, 23], // 13
			[23, 24], // 14
			[24, 25], // 15
			[25, 26], // 16
			[26, 27] // 17
		];

		TriPeaksAuthority.prototype.GetTableauNum = function (tableau) {
			if (this._tableauToNum.ContainsKey(tableau))
				return this._tableauToNum.Get(tableau);
			return -1;
		};

		TriPeaksAuthority.prototype.GetTableau = function (tableauNum) {
			if (this._numToTableau.ContainsKey(tableauNum))
				return this._numToTableau.Get(tableauNum);
			return null;
		};

		TriPeaksAuthority.prototype.GetFaceDownNum = function (tableau) {
			if (this._faceDownToNum.ContainsKey(tableau))
				return this._faceDownToNum.Get(tableau);
			return -1;
		};

		TriPeaksAuthority.prototype.GetFaceDown = function (tableauNum) {
			if (this._numToFaceDown.ContainsKey(tableauNum))
				return this._numToFaceDown.Get(tableauNum);
			return null;
		};

		TriPeaksAuthority.prototype.GetFaceDownForTableau = function (tableau) {
			var num = this.GetTableauNum(tableau);
			return this.GetFaceDown(num);
		};

		var TopRow = 4;

		TriPeaksAuthority.prototype.GetRow = function (pile) {
			var num = this.GetTableauNum(pile);
			if (num < 0) return -1;
			if (num < 3) return 1;
			if (num < 9) return 2;
			if (num < 18) return 3;
			return 4;
		};

		TriPeaksAuthority.prototype.GetTableausUnderTableau = function (tableau) {
			var piles = [];
			if (this.GetRow(tableau) == 0)
				return piles;
			var topPileNum = this.GetTableauNum(tableau);
			for (var i = 0; i < 18; i++) {
				if (TableauBlockers[i][0] == topPileNum ||
					TableauBlockers[i][1] == topPileNum)
					piles.push(this.GetTableau(i));
			}
			return piles;
		};

		TriPeaksAuthority.prototype.GetTableausRevealedByRemoving = function (tableau) {
			var tableaus = [];
			if (this.GetRow(tableau) == 0) return tableaus;
			var pilesUnder = this.GetTableausUnderTableau(tableau);
			for (var i = 0; i < pilesUnder.length; i++) {
				var under = pilesUnder[i];
				if (this.IsTheOnlyOneBlocking(tableau, under)) {
					tableaus.push(under);
				}
			}
			return tableaus;
		};

		TriPeaksAuthority.prototype.IsTableauBlocked = function (pile, butIgnoreThisTableauNum) {
			butIgnoreThisTableauNum = butIgnoreThisTableauNum || -1;

			if (pile.Type != "Tableau") return false;

			var row = this.GetRow(pile);
			var num = this.GetTableauNum(pile);
			if (num == -1)
				num = this.GetFaceDownNum(pile);

			if (row == TopRow || num > 17) return false;

			var b0num = TableauBlockers[num][0];
			var b1num = TableauBlockers[num][1];

			// if one of the blocking piles is the one we are trying to ignore, skip it.
			if (b0num == butIgnoreThisTableauNum) b0num = -1;
			if (b1num == butIgnoreThisTableauNum) b1num = -1;


			var blocker0 = this.GetTableau(b0num);
			var blocker1 = this.GetTableau(b1num);

			if (blocker0 != null && !blocker0.Empty) return true;
			if (blocker1 != null && !blocker1.Empty) return true;

			// now check the face down versions
			blocker0 = this.GetFaceDown(TableauBlockers[num][0]);
			blocker1 = this.GetFaceDown(TableauBlockers[num][1]);

			if (blocker0 != null && !blocker0.Empty) return true;
			if (blocker1 != null && !blocker1.Empty) return true;

			return false;
		};

		TriPeaksAuthority.prototype.IsPileAPeak = function (pile) {
			var p = this.GetTableauNum(pile);
			return p >= 0 && p <= 2;
		};

		TriPeaksAuthority.prototype.IsTheOnlyOneBlocking = function (blocker, blocked) {
			if (this.IsTableauBlocked(blocked) && !this.IsTableauBlocked(blocked, this.GetTableauNum(blocker)))
				return true;
			return false;
		};


		TriPeaksAuthority.prototype.WasteCanTakeCard = function (waste, card) {
			return this.WasteCanTakeCard(waste, card, false);
		};

		TriPeaksAuthority.prototype.WasteCanTakeCard = function (waste, card, triggerTips) {
			var wasteTop = waste.Top;
			if (wasteTop == null)
				return true;

			if (wasteTop.Value == CardValue.Values.Joker || card.Value == CardValue.Values.Joker)
				return true;

			if (wasteTop.Value == CardValue.Values.Ace && card.Value == CardValue.Values.King)
				return true;

			if (wasteTop.Value == CardValue.Values.King && card.Value == CardValue.Values.Ace)
				return true;

			var diff = wasteTop.ValueNum - card.ValueNum;
			if (diff == 1 || diff == -1) {
				return true;
			}
			else {
				if (triggerTips && this.OnTip != null)
					this.OnTip(this, new TipEventArgs("Tips_TriPeaks_InvalidMove"));
			}

			return false;
		};

		TriPeaksAuthority.prototype.IsActionAllowed = function (action, triggerTips) {
			if (action == null || action.Ops == null || action.Ops.length == 0)
				return false;

			var op = action.Ops[0];
			if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo) {
				// always allow an undo by itself
				return true;
			}

			if (action.IsNoop()) {
				// always allow a no-op action
				return true;
			}

			if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Game) {
				// always allow the game to be started
				return true;
			}

			if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Option) {
				// always allow options to be set (FOR NOW)
				return true;
			}

			if (op.Opcode == CardOp.Op.TotalDealsExtra) {
				return true;
			}

			if (op.Opcode == CardOp.Op.WildCardAdd) {
				return true;
			}

			if (op.Opcode == CardOp.Op.Deal) {
				// For the 2nd+ deals, EnforceGameRules will be true so we need to allow this op.
				// Makes sure that the subsequent deals are the same as the seeds set in the options.
				var seed = op.GetDeck(CardOp.eDealParams.DeckSeed);

				// see how many decks we've dealt so far
				var numDeals = this.CurrentDeal;

				// check the saved deck seed for the next deal #
				if (seed == this.CardSupply.GetOption(this.ShuffleNumberToString(numDeals)))
					return true;
				return false;
			}

			if (action.Ops.length == 1) {
				var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
				var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
				var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

				// for one action, allow:
				// moving 1 card from stock to waste
				// moving a card from Row 0 to waste

				if ((sourcePile.Type == "Stock" || sourcePile.Type == "Joker") && destPile.Type == "Waste") {
					if (numCards == 1 && !sourcePile.Empty && !this.CheckWin()) // disallow dealing if you've won the current board
					{
						return true;
					}
					return false;
				}
				else if (sourcePile.Type == "Tableau" && destPile.Type == "Waste") {
					if (numCards == 1 && !sourcePile.Empty &&
						this.WasteCanTakeCard(destPile, sourcePile.Top, triggerTips)) {
						// check if the tableaus under this one are blocked only by this card.
						// if so, they would have to be flipped, so disallow.
						var tableausRevealed = this.GetTableausRevealedByRemoving(sourcePile);
						if (this.GetRow(sourcePile) == 0 || tableausRevealed.length == 0) {
							if (sourcePile.Top.Value == CardValue.Values.King) {
								var count = this.GetTableau(0).Count + this.GetFaceDown(0).Count
									+ this.GetTableau(1).Count + this.GetFaceDown(1).Count
									+ this.GetTableau(2).Count + this.GetFaceDown(2).Count;
								if (count == 1) {
									this.WonWithKing = true;
								}
							}
							return true;
						}
					}
				}
			}
			else if (action.Ops.length == 2) {
				var opB = action.Ops[1];
				if (op.Opcode == CardOp.Op.Move && opB.Opcode == CardOp.Op.Move) {
					var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
					var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
					var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

					var sourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
					var destPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
					var numCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

					if (sourcePile.Type == "Tableau" && destPile.Type == "Waste" &&
						sourcePileB.Type == "FaceDown" && destPileB.Type == "Tableau") {
						if (numCards == 1 &&
							numCardsB == 1 && !sourcePile.Empty && !sourcePileB.Empty &&
							destPileB.Empty &&
							this.WasteCanTakeCard(destPile, sourcePile.Top, triggerTips) &&
							sourcePileB == this.GetFaceDownForTableau(destPileB)) {
							// check if the tableaus under this one are blocked only by this card.
							// if so, they would have to be flipped, so disallow.
							var tableausRevealed = this.GetTableausRevealedByRemoving(sourcePile);
							if (tableausRevealed.length == 1 && tableausRevealed[0] == destPileB) {
								return true;
							}
						}
					}
				}
			}
			else if (action.Ops.length == 3) {
				var opB = action.Ops[1];
				var opC = action.Ops[2];
				if (op.Opcode == CardOp.Op.Move && opB.Opcode == CardOp.Op.Move) {
					var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
					var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
					var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

					var sourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
					var destPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
					var numCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

					var sourcePileC = opC.GetPile(CardOp.eMoveParams.SourcePile);
					var destPileC = opC.GetPile(CardOp.eMoveParams.DestPile);
					var numCardsC = opC.GetNumber(CardOp.eMoveParams.NumCards);

					// check for the case where wasting one card flips over the two underneath.

					if (sourcePile.Type == "Tableau" && destPile.Type == "Waste" &&
						sourcePileB.Type == "FaceDown" && destPileB.Type == "Tableau" &&
						sourcePileC.Type == "FaceDown" && destPileC.Type == "Tableau") {
						if (
							numCards == 1 &&
							numCardsB == 1 &&
							numCardsC == 1 && !sourcePile.Empty && !sourcePileB.Empty && !sourcePileC.Empty &&
							destPileB.Empty &&
							destPileC.Empty &&
							destPileC != destPileB &&
							this.WasteCanTakeCard(destPile, sourcePile.Top, triggerTips) &&
							sourcePileB == this.GetFaceDownForTableau(destPileB) &&
							sourcePileC == this.GetFaceDownForTableau(destPileC)) {
							var tableausRevealed = this.GetTableausRevealedByRemoving(sourcePile);
							if (tableausRevealed.length == 2 &&
								(tableausRevealed[0] == destPileB && tableausRevealed[1] == destPileC) ||
								(tableausRevealed[1] == destPileB && tableausRevealed[0] == destPileC)) {
								return true;
							}
						}
					}
				}
			}

			return false;
		};

		TriPeaksAuthority.prototype.CanAutoSolve = function () {
			return false;
		};

		TriPeaksAuthority.prototype.CanKeyboardFocusCard = function (card) {
			if (!this.CanPickupCard(card))
				return false;
			if (card.Pile.Type == "Tableau")
				return !this.IsTableauBlocked(card.Pile);
			return true;
		};


		TriPeaksAuthority.prototype.CanPickupCard = function (card) {
			if (this.CardSupply.WaitingForBlockingAnimation)
				return false;

			if (card.Pile.Type == "Tableau")
				return true;
			return false;
		};

		TriPeaksAuthority.prototype.CanAcceptCards = function (pile) {
			if (pile.Type == "Waste")
				return true;
			return false;
		};

		TriPeaksAuthority.prototype.IsGameWon = function () {
			if (this.CardSupply.WaitingForAnimation) {
				// We don't win unless the card animation is finished.
				return false;
			}
			if (this.CheckWin()) {
				this.WriteSolvableDeckLog();
				this.Deal();
			}
			return false;
		};

		TriPeaksAuthority.prototype.WriteSolvableDeckLog = function () {
			/*
			 #if WRITE_SOLVABLE_DECKS
			 if (!IsChallenge)
			 {
			 FileManager.Current.WriteTextFileAsync(
			 "Game: TriPeaks\nSeed: " + CardSupply.DeckSeed,
			 "TriPeaksSolvableDeck_" + DateTime.Now.ToString().Replace('/', '-').Replace(':', '.') + ".log",
			 FileSource.StorageFiles);
			 }
			 #endif
			 */
		};

		TriPeaksAuthority.prototype.CheckWin = function () {
			if (this.GetTableau(0).Count == 0 && this.GetFaceDown(0).Count == 0
				&& this.GetTableau(1).Count == 0 && this.GetFaceDown(1).Count == 0
				&& this.GetTableau(2).Count == 0 && this.GetFaceDown(2).Count == 0) {
				return true;
			}

			return false;
		};

		TriPeaksAuthority.prototype.GetCompletedStacks = function () {
			return 0;
		};


		TriPeaksAuthority.prototype.GetScoreForAction = function (action) {
			var score = 0;
			for (var i = 0; i < action.Ops.length; i++) {
				var op = action.Ops[i];
				var src = op.GetPile(CardOp.eMoveParams.SourcePile);
				var dst = op.GetPile(CardOp.eMoveParams.DestPile);

				if (op.Opcode == CardOp.Op.Move && src.Type == "Tableau" && dst.Type == "Waste") {
					var tableauNumber = this.GetTableauNum(src);

					score += 100 + 200 * this._chainNumber;
					if (((action.Tag & TagChainnumber) >>> 0) == 0)
						this._chainNumber++;
					else score -= 200;

					if (tableauNumber < 3) {
						var numPeaksCleared = 0;
						if ((this.GetTableau(0).Count == 0 && this.GetFaceDown(0).Count == 0) || tableauNumber == 0) {
							numPeaksCleared++;
						}
						if ((this.GetTableau(1).Count == 0 && this.GetFaceDown(1).Count == 0) || tableauNumber == 1) {
							numPeaksCleared++;
						}
						if ((this.GetTableau(2).Count == 0 && this.GetFaceDown(2).Count == 0) || tableauNumber == 2) {
							numPeaksCleared++;
						}

						this.NumPeaksCleared = 3 * this.NumBoardsCompleted + numPeaksCleared;

						if (numPeaksCleared == 3 && ((action.Tag & TagChainnumber) >>> 0) == 0) {
							if (this.IsChallenge && this.SuppressBonusAnimations) {
								this.NumBoardsCompleted++;
								this.CardSupply.OnBoardCompletedEvent.handleEvent(this.NumBoardsCompleted);
							}
							else {
								setTimeout(function () {
									this.NumBoardsCompleted++;
									this.CardSupply.OnBoardCompletedEvent.handleEvent(this.NumBoardsCompleted);
								}.bind(this), 2250);
							}
						}

						var bonus = 0;
						switch (numPeaksCleared) {
							case 1:
								bonus = 500;
								break;
							case 2:
								bonus = 1000;
								break;
							case 3:
								bonus = 5000;
								break;
						}

						score += bonus;

						if (this.onBonusEffectEventHanlder != null && bonus > 0 && !this.SuppressBonusAnimations) {
							this.onBonusEffectEventHanlder.handleEvent(this, {
								pile: src,
								bonus: bonus,
								peaks: numPeaksCleared,
								isPerfect: numPeaksCleared == 3
							});
						}
					}
				}
				else if (op.Opcode == CardOp.Op.Move && src.Type == "Stock") {
					if (this._chainNumber > this.CardsChained)
						this.CardsChained = this._chainNumber;
					this._chainNumber = 0;
				}
				else if (op.Opcode == CardOp.Op.Undo) {
					if (this._chainNumber > this.CardsChained)
						this.CardsChained = this._chainNumber;
					this._chainNumber = 0;
					return 0;
				}
			}
			action.Tag = (action.Tag | this._chainNumber) >>> 0; // TODO - why are we doing this?
			return score;
		};

		TriPeaksAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer) {
			return 0;
		};

		TriPeaksAuthority.prototype.GetBonusScore = function (totalTimer) {
			return 0;
		};

		TriPeaksAuthority.prototype.GetMaxScore = function () {
			return Number.MAX_VALUE;
		};

		TriPeaksAuthority.prototype.GetMinScore = function () {
			return 0;
		};

		TriPeaksAuthority.prototype.GetStartingScore = function () {
			return 0;
		};

		TriPeaksAuthority.prototype.GetStartingTime = function () {
			return 0;
		};

		TriPeaksAuthority.prototype.GetHint = function (cycle) {
			cycle = !!cycle;
			return this.GetHintInternal(cycle);
		};

		TriPeaksAuthority.prototype.GetHintInternal = function (cycle) {
			cycle = !!cycle;
			var numTableaus = 28;

			var hints = [];

			var source;
			var waste = this.CardSupply.GetPile("Waste");

			// Tableau-a-waste.
			for (var i = numTableaus - 1; i >= 0; i--) {
				source = this.CardSupply.GetPile("Tableau" + i);
				if (source.Empty)
					continue;

				if (this.WasteCanTakeCard(waste, source.Top)) {
					var hint = new CardOp(this.CardSupply);
					var args = ["MOVE", source.Name, source.Name, "1"];
					hint.Parse(args, 0);
					hints.push(hint);
				}
			}

			source = this.CardSupply.GetPile("Joker");
			if (source.GetCards().length > 0) {
				if (this.WasteCanTakeCard(waste, source.Top)) {
					var hint = new CardOp(this.CardSupply);
					var args = ["MOVE", source.Name, source.Name, "1"];
					hint.Parse(args, 0);
					hints.push(hint);
				}
			}

			if (!cycle && hints.length > 0)
				return hints[0];

			// Otherwise, stock-a-waste.
			source = this.CardSupply.GetPile("Stock");

			if (!source.Empty /*|| NumDealsLeft() > 0*/) {
				var hint = new CardOp(this.CardSupply);
				var args = ["MOVE", "Stock", "Stock", "1"];
				hint.Parse(args, 0);
				hints.push(hint);
			}

			if (hints.length > 0) {
				if (!cycle) {
					return hints[0];
				}
				else if (cycle) {
					if (this._lastHint != null) {
						// Find the position of the last hint in the hint list (if possible).
						var index;
						for (index = 0; index < hints.length; index++) {
							if (hints[index].Equals(this._lastHint))
								break;
						}

						if (index >= hints.length - 1) {
							var hint = hints[0];
							this._lastHint = hint;
							return hint;
						}
						else {
							var hint = hints[index + 1];
							this._lastHint = hint;
							return hint;
						}
					}
					else {
						var hint = hints[0];
						this._lastHint = hint;
						return hint;
					}
				}
			}

			return new CardOp(this.CardSupply);
		};

		TriPeaksAuthority.prototype.GetAutomaticMove = function () {
			// Automatic moves not supported.
			return null;
		};

		TriPeaksAuthority.prototype.CurrentMoveState = function () {
			if (this.CardSupply.WaitingForAnimation || this.IsGameWon())
				return MoveState.CanMove;

			if (this.GetHintInternal().Opcode == CardOp.Op.Noop) {
				if (this.CurrentDeal >= this.TotalDeals)
					return MoveState.NoMovesLeft;
				return MoveState.CanDealNextDeck;
			}

			return MoveState.CanMove;
		};

		TriPeaksAuthority.prototype.AllowDealNextDeck = function () {
			return this.CardSupply.GetPile("Stock").Empty;
		};

		TriPeaksAuthority.prototype.ResetNoMoreMovesState = function () {
			// Do nothing.
		};

		TriPeaksAuthority.prototype.TriggerTip = function (e) {
			if (this.OnTip != null)
				this.OnTip(this, e);
		};

		TriPeaksAuthority.prototype.OnRunAction = function (action, undo, triggerTips) {
			for (var i = 0; i < action.Ops.length; i++) {
				var op = action.Ops[i];

				var srcPile = op.GetPile(CardOp.eMoveParams.SourcePile);
				var dstPile = op.GetPile(CardOp.eMoveParams.DestPile);

				if (op.Opcode != CardOp.Op.Move) {
					continue;
				}
				if (srcPile.Type != "Stock") {
					if (undo) {
						this.CardsClearedWerePeaks.pop();
					}
					else {
						this.CardsClearedWerePeaks.push(this.IsPileAPeak(srcPile));
					}
				}
				if (srcPile.Type == "Tableau" && dstPile.Type == "Waste") {
					this._currentCardsRemovedWithoutUsingStock = Math.max(0, undo ? this._currentCardsRemovedWithoutUsingStock - 1 : this._currentCardsRemovedWithoutUsingStock + 1);
				}
				else if (srcPile.Type == "Stock") {
					this._currentCardsRemovedWithoutUsingStock = 0;
				}
			}
			this.MaxCardsRemovedWithoutUsingStock = Math.max(this._currentCardsRemovedWithoutUsingStock, this.MaxCardsRemovedWithoutUsingStock);
		};

		TriPeaksAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
		};

		TriPeaksAuthority.prototype.OnGameOver = function (fullActionList, collapsedActionList) {

		};

		TriPeaksAuthority.prototype.GenerateDealData = function () {
			var i, res;
			var cardIndex = 0;

			var script = "";
			var deck = new Array(this.CardSupply.Count);

			res = this.ProcessDealDataForPile("Stock", deck, script, cardIndex);
			deck = res.deck;
			script = res.script;
			cardIndex = res.cardIndex;
			res = this.ProcessDealDataForPile("Waste", deck, script, cardIndex);
			deck = res.deck;
			script = res.script;
			cardIndex = res.cardIndex;
			for (i = 27; i >= 0; i--) {
				res = this.ProcessDealDataForPile("Tableau" + i, deck, script, cardIndex);
				deck = res.deck;
				script = res.script;
				cardIndex = res.cardIndex;
				res = this.ProcessDealDataForPile("FaceDown" + i, deck, script, cardIndex);
				deck = res.deck;
				script = res.script;
				cardIndex = res.cardIndex;
			}

			script = "BEGIN " + script + "END";
			return new DealData(Pile.ConstructSeedFromDeck(deck, this.CardSupply.Count).ToString(), script); // TODO lower case toString?
		};

		/// <summary>
		/// add extra deals for opt in ads
		/// </summary>
		/// <param name="dealsCnt"></param>
		/// <param name="logAction"> </param>
		TriPeaksAuthority.prototype.AddExtraDeals = function (dealsCnt, logAction) {
			if (typeof logAction == 'undefined') logAction = true;

			this.TotalDeals += dealsCnt;

			if (logAction)
				this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["TotalExtraDeal", dealsCnt.toString()]));
		}

		TriPeaksAuthority.prototype.AddWildCard = function (logAction) {
			if (typeof logAction == 'undefined') logAction = true;

			var cardList = this.CardSupply.GetCardList();
			for (var i = 0; i < cardList.length; i++) {
				var card = cardList[i];
				if (card.Value == CardValue.Values.Joker && card.Suit == CardSuit.None) {
					var pile = this.CardSupply.GetPile("Joker");
					pile.AddNew(card);
					this.CardSupply.WildCardAdded();
					break;
				}
			}

			if (logAction)
				this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["WildCardAdd"]));
		};

		TriPeaksAuthority.prototype.ApplyCurrentOptInAdBonus = function (bonusType) {
			if (bonusType == 'extraDeal') {
				this.AddExtraDeals(1);
				this.Deal();
			} else if (bonusType == 'wildCard') {
				this.AddWildCard();
			}
		};


		TriPeaksAuthority.prototype.ProcessDealDataForPile = function (pileName, deck, script, currentIndex) {
			var currentPile = this.CardSupply.GetPile(pileName);

			if (currentPile != null && !currentPile.Empty) {
				_.forEach(currentPile.GetCards(), function (card) {
					deck[currentIndex++] = card.Sequence;
				});
				script = "MOVE Root " + pileName + " " + currentPile.Count + " " + script;
			}
			return {deck: deck, script: script, currentIndex: currentIndex};
		};

		TriPeaksAuthority.prototype.ForceDealScript = function (script) {
			this.DealScript = (script != null ? script : TriPeaksAuthority.DefaultDealScript);
		};


		TriPeaksAuthority.DefaultDealScript =
			"BEGIN " +
			"MOVE Root Stock 52 " +

			"MOVE Stock FaceDown0 1 " +
			"MOVE Stock FaceDown1 1 " +
			"MOVE Stock FaceDown2 1 " +

			"MOVE Stock FaceDown3 1 " +
			"MOVE Stock FaceDown4 1 " +
			"MOVE Stock FaceDown5 1 " +
			"MOVE Stock FaceDown6 1 " +
			"MOVE Stock FaceDown7 1 " +
			"MOVE Stock FaceDown8 1 " +

			"MOVE Stock FaceDown9 1 " +
			"MOVE Stock FaceDown10 1 " +
			"MOVE Stock FaceDown11 1 " +
			"MOVE Stock FaceDown12 1 " +
			"MOVE Stock FaceDown13 1 " +
			"MOVE Stock FaceDown14 1 " +
			"MOVE Stock FaceDown15 1 " +
			"MOVE Stock FaceDown16 1 " +
			"MOVE Stock FaceDown17 1 " +

			"MOVE Stock Tableau18 1 " +
			"MOVE Stock Tableau19 1 " +
			"MOVE Stock Tableau20 1 " +
			"MOVE Stock Tableau21 1 " +
			"MOVE Stock Tableau22 1 " +
			"MOVE Stock Tableau23 1 " +
			"MOVE Stock Tableau24 1 " +
			"MOVE Stock Tableau25 1 " +
			"MOVE Stock Tableau26 1 " +
			"MOVE Stock Tableau27 1 " +

			"MOVE Stock Waste 1 " +

			"END";

		return TriPeaksAuthority;

	});
